import {SecurityIgnoredIssue} from "./security-ignored-issue";
import {Utils} from '../../../shared/utils/utils';

export class SecurityIgnoredIssueMapper {

  public static map(data: any): SecurityIgnoredIssue {
    const securityIgnoredIssue: SecurityIgnoredIssue = new SecurityIgnoredIssue();

    securityIgnoredIssue.id = data._id;
    securityIgnoredIssue.type = data.type;
    securityIgnoredIssue.fileName = data.file_name;
    securityIgnoredIssue.file_path = data.file_path;
    securityIgnoredIssue.status = data.status;
    securityIgnoredIssue.selected = false;
    securityIgnoredIssue.createDate = data.created_at ? Utils.getDate(data.created_at) : null;
    securityIgnoredIssue.updateDate = data.updated_at ? Utils.getDate(data.updated_at) : null;

    return securityIgnoredIssue;
  }

}
